import moment from 'moment'
import { TOGGLE_YLOPO_OPT_IN_MODAL, SET_YLOPO_LISTINGS } from './actionTypes'
import { QUESTION_YLOPO_OPT_IN } from 'src/constants/client/answers'
import { saveClientAnswer } from 'src/actions/client'

export const answerYlopoOptIn = () => async dispatch => {
  dispatch(
    saveClientAnswer({
      question: QUESTION_YLOPO_OPT_IN,
      response: {
        value: moment().toJSON()
      }
    })
  )
}

export const toggleYlopoOptInModal = ylopoUrl => ({
  type: TOGGLE_YLOPO_OPT_IN_MODAL,
  ylopoUrl
})

export const setYlopoListings = (listings, tag) => ({
  type: SET_YLOPO_LISTINGS,
  listings,
  tag
})
